import * as yup from 'yup';
export const validationSchema = yup.object().shape({
    InsuredBirthDate: yup
        .string()
        .required('Обязательное поле')
        .matches(
            /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
            'Неверная дата'
        )
        .test(
            'is-valid-date',
            'Некорректная дата',
            (value) => {
                const [day, month, year] = value.split('.').map(Number);
                const date = new Date(year, month - 1, day);
                const minDate = new Date(1915, 0, 1);
                return (
                    date.getFullYear() === year &&
                    date.getMonth() === month - 1 &&
                    date.getDate() === day &&
                    date >= minDate
                );
            }
        )
        .test(
            'is-age-in-range',
            'Возраст должен быть от 1 до 70 лет',
            (value) => {
                if (!value) return false;
                const [day, month, year] = value.split('.').map(Number);
                const birthDate = new Date(year, month - 1, day);
                if (isNaN(birthDate.getTime())) return false;
                const today = new Date();
                const maxBirthDate = new Date(today);
                maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 70);
                const minBirthDate = new Date(today);
                minBirthDate.setFullYear(minBirthDate.getFullYear() - 1);
                return birthDate.getTime() >= maxBirthDate.getTime() && birthDate.getTime() <= minBirthDate.getTime();
            }
        )
});